import { render } from "./ScrollCard.vue?vue&type=template&id=83e04556&ts=true"
import script from "./ScrollCard.vue?vue&type=script&lang=ts"
export * from "./ScrollCard.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__